import defaultSettings from '@/settings'

const title = defaultSettings.title || '大强时代城中短运管理后台'

export default function getPageTitle(pageTitle) {
  if (pageTitle) {
    return `${pageTitle} - ${title}`
  }
  return `${title}`
}
